<script lang="ts" setup>
  import { nodeViewProps, NodeViewWrapper } from '@tiptap/vue-3';
  import { computed } from 'vue';
  import EmbeddedFrame from './EmbeddedFrame.vue';

  const props = defineProps(nodeViewProps);

  const url = computed(() => props.node.attrs.url);
</script>

<template>
  <node-view-wrapper>
    <embedded-frame :url="url" />
  </node-view-wrapper>
</template>
